<div class="bg-white border p-4 rounded-sm w-fit text-sm select-none shadow-lg">

  <div class="flex justify-between items-center mb-2 font-semibold">
    <button class="px-1" (click)="prevMonth()">
      <i class="fas fa-angle-left transition-transform rtl:rotate-180"></i>
    </button>
    <span>{{ visible | date : "MMMM yyyy" }}</span>
    <button class="px-1" (click)="nextMonth()">
      <i class="fas fa-angle-right transition-transform rtl:rotate-180"></i>
    </button>
  </div>

  <!-- weekday labels -->
  <div class="grid grid-cols-7 gap-1 text-center text-xs text-gray-500 mb-1">
    @for (w of weekdays; track $index) {
      <span>{{ w }}</span>
    }
  </div>

  <!-- day grid (6 rows × 7 columns) -->
  <div class="grid grid-cols-7 gap-1 text-center">
    @for (cell of monthGrid; track $index) {
      <!-- empty cells -->
      @if (!cell) {
        <span></span>
      }
      <!-- date cells -->
      @if (cell) {
        <button
          class="w-7 h-7 rounded hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed"
          [class.bg-dc-navy]="isSelected(cell)"
          [class.text-white]="isSelected(cell) || isBooked(cell)"
          [class.bg-red-600]="!isSelected(cell) && isBooked(cell)"
          [disabled]="isDisabled(cell)"
          (click)="pickDate(cell)"
          >
          {{ cell.getDate() }}
        </button>
      }
    }
  </div>
</div>
